var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "10px" } },
    [
      _c(
        "el-card",
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  key: 0,
                  attrs: {
                    label: _vm.$t("tablePrice.siteDimensionTab"),
                    name: "first",
                  },
                },
                [_vm.isShow ? _c("siteIndex") : _vm._e()],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  key: 1,
                  attrs: {
                    label: _vm.$t("tablePrice.regionDimensionTab"),
                    name: "second",
                  },
                },
                [_vm.isShow1 ? _c("regionIndex") : _vm._e()],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  key: 2,
                  attrs: {
                    label: _vm.$t("tablePrice.customerDimensionTab"),
                    name: "third",
                  },
                },
                [_vm.isShow2 ? _c("customerIndex") : _vm._e()],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  key: 3,
                  attrs: {
                    label: _vm.$t("tablePrice.riderDimensionTab"),
                    name: "fourth",
                  },
                },
                [_vm.isShow3 ? _c("riderIndex") : _vm._e()],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }